{
  "brandName": "KhataRasoi",
  "productName": "KhataRasoi POS",
  "productShortName": "KhataRasoi",
  "tagline": "Har Order Ka Hisaab.",
  "companyName": "KhataRasoi",
  "cloudConsoleName": "KhataRasoi Cloud",
  "controlName": "KhataRasoi Control",
  "ownerAppName": "KhataRasoi Owner",
  "orderAppName": "KhataRasoi Order",
  "staffAppName": "KhataRasoi Waiter",
  "kitchenAppName": "KhataRasoi Kitchen",
  "copyright": "Copyright (c) 2026 KhataRasoi.",
  "desktop": {
    "appId": "com.khatarasoi.pos",
    "linuxExecutableName": "khatarasoi",
    "mdnsName": "khatarasoi",
    "updateFeed": {
      "provider": "github",
      "owner": "Shreyansh1729",
      "repo": "khatarasoi-releases",
      "releaseType": "draft",
      "channel": "latest"
    },
    "msStore": {
      "applicationId": "KhataRasoiPOS",
      "identityName": "KhataRasoi.KhataRasoiPOS",
      "publisher": "CN=00000000-0000-0000-0000-000000000000",
      "publisherDisplayName": "KhataRasoi"
    },
    "artifactPrefix": "khatarasoi",
    "macSigningIdentity": null
  },
  "mobile": {
    "ownerBundleId": "com.khatarasoi.owner",
    "ownerAndroidPackage": "com.khatarasoi.owner",
    "ownerScheme": "khatarasoiowner"
  },
  "urls": {
    "cloudApi": "",
    "orderApp": "",
    "adminApp": "",
    "website": "https://khatarasoi.in",
    "support": "https://khatarasoi.in/support/",
    "documentation": "https://khatarasoi.in/documentation/",
    "terms": "https://khatarasoi.in/terms/",
    "privacy": "https://khatarasoi.in/privacy/",
    "telemetryCollector": "",
    "disclaimer": "",
    "ownerAppIos": "",
    "ownerAppAndroid": "",
    "ownerAppLanding": "",
    "communityChat": ""
  },
  "supportEmail": "support@khatarasoi.in",
  "supportPhone": "+91 6026013891",
  "location": "Varanasi, Uttar Pradesh, India",
  "theme": {
    "primary": "#FF6B00",
    "primaryDark": "#C44D00",
    "primaryHover": "#A34000",
    "primaryForeground": "#FFFFFF",
    "accent": "#FF6B00",
    "background": "#FFFFFF",
    "surface": "#FFFFFF",
    "surfaceMuted": "#FAFAFA",
    "border": "#E5E5E5",
    "text": "#171717",
    "textMuted": "#4B5563",
    "white": "#FFFFFF",
    "dark": {
      "background": "#121212",
      "surface": "#1C1C1C",
      "surfaceMuted": "#262626",
      "border": "#333333",
      "text": "#F5F5F5",
      "textMuted": "#B3B3B3",
      "accent": "#FF8A3D",
      "button": "#FF7A1A",
      "buttonForeground": "#111827"
    },
    "radius": "0.75rem"
  },
  "features": {
    "qrOrdering": true,
    "cloudSync": true,
    "onlinePayments": false,
    "telemetry": false
  },
  "licensing": {
    "entitlementPublicKey": "MCowBQYDK2VwAyEANLmRao0ihlcva7m3BVg9PQmnlXo4gY/Ujvuuwi/xZJo="
  },
  "legacyNames": {
    "FloCafe": "productName",
    "Flo Cafe": "productName",
    "FloAdmin": "cloudConsoleName",
    "RevFlow": "ownerAppName",
    "RevFlo": "ownerAppName",
    "FloPOS": "companyName",
    "FreeOpenSourcePOS": "companyName",
    "flo.local": "localEmailDomain",
    "Flo": "productShortName",
    "FloAdministrator": "cloudConsoleName",
    "FloDesktop": "productName",
    "OrderFlow": "onlineOrderingName"
  },
  "localEmailDomain": "khatarasoi.local",
  "onlineOrderingName": "KhataRasoi Online Orders"
}
